<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="contentt"></mobile-menu>
      <el-menu
        :default-active="routerPath"
        class="el-menu-vertical-demo"
        background-color="#000"
        text-color="#fff"
        active-text-color="#ffd04b"
        router
      >
        <el-menu-item index="/Guest/UserManagement">
          <i class="menu-icon nc-icon nc-paper-2"></i>
          <span slot="title">普通用户</span>
        </el-menu-item>
        <el-menu-item index="/Guest/GuestManagement">
          <i class="menu-icon nc-icon nc-single-copy-04"></i>
          <span slot="title">嘉宾管理</span>
        </el-menu-item>
      </el-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
        <dashboard-content @click="toggleSidebar">
        <router-view></router-view>
      </dashboard-content>
      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "../TopNavbar";
import ContentFooter from "../ContentFooter.vue";
import DashboardContent from "../Content.vue";
import MobileMenu from "../MobileMenu.vue";
export default {
  name: "dashboard-layot",
  data() {
    return {
      routerPath: "/Guest/GuestManagement"
    };
  },
    mounted(){
 let defaultMenu = window.location.hash.substr(
      window.location.hash.indexOf("/")
    );
    this.routerPath = defaultMenu;
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
<style  scoped>
.el-menu{
  border: 0;
}
.menu-icon {
  margin-right: 10px;
  font-size: 20px;
  line-height: 56px;
}
.el-menu-item.is-active::after {
  content: "";
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  z-index: 99;
  left: 0;
  top: 0;

}

</style>
